/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
    mdiOfficeBuildingCog,
    mdiHome,
    mdiCarMultiple,
    mdiHandExtended,
    mdiClipboardCheckOutline,
    mdiAnimation,
    mdiTagText,
    mdiAccountTieHat,
    mdiRun,
    mdiAirplane,
    mdiStoreCog,
    mdiCog,
    mdiTune,
    mdiCalendarMonth,
    mdiFinance,
    mdiNotebookMultiple,
    mdiCash,
    mdiSchool,
    mdiWatermark,
    mdiCashMultiple,
    mdiFaceAgent,
    mdiAccount
  } from '@mdi/js'

  export default [
    'General',
    [
      {
        label: 'Room Booking',
        to: '/booking-dashboard',
        icon: mdiStoreCog
      }
    ],
    'Examples',
    [
        {
            label: 'Facility Booking',
            subLabel: 'Submenus Booking',
            icon: mdiStoreCog,
            menu: [
                {
                    to: '/building',
                    label: 'Building',
                    icon: mdiOfficeBuildingCog
                },
                {
                    to: '/room',
                    label: 'Room',
                    icon: mdiHome
                    // icon: mdiAccountTie
                },
                {
                    to: '/vehicle',
                    label: 'Vehicle',
                    icon: mdiCarMultiple
                    // icon: mdiAccountTie
                },
                {
                    to: '/facility',
                    label: 'Facility',
                    icon: mdiHandExtended
                },
                {
                    to: '/facility-condition',
                    label: 'Facility Condition',
                    icon: mdiClipboardCheckOutline
                },
                {
                    to: '/fa-category',
                    label: 'Category Facility',
                    icon: mdiAnimation
                },
                {
                    to: '/pricelist',
                    label: 'Price List',
                    icon: mdiTagText
                },
                // {
                // 	to: '/owner',
                // 	label: 'Owner',
                // 	icon: mdiAccountStar
                // },
                {
                    to: '/tenant',
                    label: 'Tenant',
                    icon: mdiAccountTieHat
                },
                {
                    to: '/activity',
                    label: 'Activity',
                    icon: mdiRun
                },
                {
                    to: '/holiday',
                    label: 'Holiday',
                    icon: mdiAirplane
                },
                {
                    to: '/financialyear',
                    label: 'finance.sidebar.master.finYear',
                    icon: mdiCalendarMonth
                },
                {
                    to: '/coa',
                    label: 'finance.sidebar.master.coa',
                    icon: mdiFinance,
                    updateMark: true
                },
                {
                    to: '/typejournal',
                    label: 'finance.sidebar.master.journalType',
                    icon: mdiNotebookMultiple
                },
                {
                    to: '/typesofincome',
                    label: 'finance.sidebar.incomes.incType',
                    icon: mdiCash
                },
                {
                    to: '/incomegroup',
                    label: 'finance.sidebar.incomes.groupType',
                    icon: mdiCash
                }
            ]
        }
  ],
    'Setting',
    [
        {
            label: 'Transaction',
            subLabel: 'Transaction',
            icon: mdiCashMultiple,
            menu: [
                {
                    to: '/transaction-type',
                    label: 'Transaction Type',
                    icon: mdiCashMultiple
                },
                {
                    to: '/transaction-group',
                    label: 'Transaction Group',
                    icon: mdiCashMultiple
                }
            ]
        },
        {
            label: 'Roles',
            subLabel: 'Roles',
            icon: mdiFaceAgent,
            menu: [
                {
                    to: '/role',
                    label: 'Role',
                    icon: mdiFaceAgent
                },
                {
                    to: '/role-group',
                    label: 'Role Group',
                    icon: mdiFaceAgent
                }
            ]
        },
        {
            label: 'Settings',
            subLabel: 'Submenus Settings Booking',
            icon: mdiCog,
            menu: [
                {
                    to: '/schoolidentity',
                    label: 'Entity',
                    icon: mdiSchool
                },
                {
                    to: '/branch',
                    label: 'Branch',
                    icon: mdiWatermark
                },
                {
                    to: '/setting-rental',
                    label: 'Setting Rental',
                    icon: mdiTune
                },
                {
                    to: '/users',
                    label: 'Users',
                    icon: mdiAccount
                }
            ]
        }
  ]
]
